// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   WORKSPACE - Modern Dashboard Layout
   Con elevation, depth y layered UI
   ============================================ */

/* Variables */
:root {
  --bg-base: #f0f2f5;
  --bg-surface: #ffffff;
  --bg-elevated: #ffffff;
  --bg-sunken: #f8f9fb;
  --border-light: #e8eaed;
  --border-medium: #dadce0;
  --text-primary: #1a1d21;
  --text-secondary: #5f6368;
  --text-muted: #9aa0a6;
  --accent: #1a73e8;
  --accent-light: #e8f0fe;
  --accent-dark: #1557b0;
  --success: #1e8e3e;
  --success-bg: #e6f4ea;
  --warning: #f9ab00;
  --warning-bg: #fef7e0;
  --error: #d93025;
  --error-bg: #fce8e6;
  --shadow-sm: 0 1px 2px rgba(0,0,0,0.05);
  --shadow-md: 0 2px 8px rgba(0,0,0,0.08);
  --shadow-lg: 0 4px 16px rgba(0,0,0,0.12);
  --shadow-xl: 0 8px 32px rgba(0,0,0,0.16);
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
}

/* Layout principal */
.workspace {
  display: flex;
  min-height: 100vh;
  background: var(--bg-base);
}

/* ============================================
   SIDEBAR IZQUIERDA
   ============================================ */
.sidebar-left {
  width: 260px;
  min-width: 260px;
  height: 100vh;
  position: sticky;
  top: 0;
  background: linear-gradient(180deg, #1a1d24 0%, #252830 100%);
  color: #e4e6eb;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
  z-index: 10;
}

.sidebar-sections {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  font-weight: 600;
  font-size: 15px;
}

.sidebar-logo svg {
  color: #4d9fff;
}

.sidebar-section {
  padding: 8px 12px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 4px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: #9ca3af;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  cursor: pointer;
  transition: all 0.15s;
}

.section-header:hover {
  background: rgba(255,255,255,0.04);
  color: #e4e6eb;
}

.section-content {
  padding: 0 4px;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: #b8bcc4;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s;
}

.sidebar-item:hover {
  background: rgba(255,255,255,0.06);
  color: #ffffff;
}

.sidebar-item.active {
  background: rgba(77, 159, 255, 0.15);
  color: #4d9fff;
}

.item-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.5;
}

.sidebar-item.active .item-dot {
  background: #4d9fff;
  opacity: 1;
}

.item-text {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.session-actions {
  display: none;
  align-items: center;
  gap: 2px;
}

.sidebar-item:hover .session-actions {
  display: flex;
}

.session-btn {
  padding: 4px;
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.session-btn.edit:hover {
  background: rgba(255,255,255,0.1);
  color: #4d9fff;
}

.session-btn.delete:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.session-edit-input {
  flex: 1 1;
  padding: 2px 6px;
  background: rgba(255,255,255,0.1);
  border: 1px solid #4d9fff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 13px;
  outline: none;
}

.sidebar-item.new-item {
  color: #4d9fff;
  font-size: 12px;
  opacity: 0.9;
}

.sidebar-item.agent-item {
  position: relative;
  padding-left: 18px;
}

.sidebar-item.agent-item::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: var(--agent-color);
  border-radius: 0 2px 2px 0;
  transition: height 0.15s;
}

.sidebar-item.agent-item.active::before {
  height: 22px;
}

.agent-icon {
  font-size: 15px;
}

.sidebar-footer {
  margin-top: auto;
  padding: 12px;
  background: #15171c;
  border-top: 1px solid rgba(255,255,255,0.06);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: var(--radius-sm);
  color: #9ca3af;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
}

.footer-btn:hover {
  background: rgba(255,255,255,0.08);
  color: #e4e6eb;
}

.footer-brand {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.06);
  font-size: 11px;
  color: #6b7280;
  text-align: center;
}

/* ============================================
   AREA PRINCIPAL
   ============================================ */
.main-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  background: var(--bg-base);
}

.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  height: 64px;
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border-light);
  box-shadow: var(--shadow-sm);
  z-index: 5;
}

.tabs {
  display: flex;
  gap: 6px;
  padding: 4px;
  background: var(--bg-sunken);
  border-radius: var(--radius-md);
}

.tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}

.tab:hover {
  color: var(--text-primary);
}

.tab.active {
  background: var(--bg-surface);
  color: var(--accent);
  box-shadow: var(--shadow-sm);
}

.tab-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 7px;
  height: 7px;
  background: var(--accent);
  border-radius: 50%;
}

.tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: var(--border-light);
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
}

.tab.active .tab-count {
  background: var(--accent-light);
  color: var(--accent);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.project-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

.main-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 28px;
  width: 100%;
}

/* ============================================
   COMPONENTES COMUNES - Panels con depth
   ============================================ */
.panel {
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);
  border-bottom: 1px solid var(--border-light);
}

.panel-header .btn-icon {
  opacity: 1;
  color: var(--text-secondary);
}

.panel-header .btn-icon:hover {
  background: var(--accent-light);
  color: var(--accent);
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.panel-title svg {
  color: var(--text-secondary);
}

.panel-title h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.panel-title .badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  background: var(--accent-light);
  border-radius: 11px;
  font-size: 11px;
  font-weight: 600;
  color: var(--accent);
}

.panel-body {
  flex: 1 1;
  padding: 16px;
  overflow-y: auto;
}

.panel-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--bg-sunken);
  border-top: 1px solid var(--border-light);
}

/* Botones comunes */
.btn-upload {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: var(--accent);
  border: none;
  border-radius: var(--radius-sm);
  color: white;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 2px 4px rgba(26, 115, 232, 0.3);
}

.btn-upload:hover {
  background: var(--accent-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(26, 115, 232, 0.35);
}

.btn-upload input {
  display: none;
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.15s;
  opacity: 0;
}

.btn-icon.delete:hover {
  background: var(--error-bg);
  color: var(--error);
}

.btn-icon.remove {
  opacity: 1;
  background: var(--bg-sunken);
}

.btn-icon.remove:hover {
  background: var(--error-bg);
  color: var(--error);
}

.btn-text {
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.btn-text:hover {
  background: var(--border-light);
  color: var(--text-primary);
}

.btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.primary {
  background: var(--accent);
  color: white;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
}

.btn.primary:hover:not(:disabled) {
  background: var(--accent-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

.btn.secondary {
  background: var(--bg-sunken);
  border: 1px solid var(--border-medium);
  color: var(--text-primary);
}

.btn.secondary:hover:not(:disabled) {
  background: var(--border-light);
}

.btn.danger {
  background: #dc2626;
  border: none;
  color: white;
}

.btn.danger:hover:not(:disabled) {
  background: #b91c1c;
}

.btn.large {
  padding: 14px 28px;
  font-size: 15px;
}

/* Empty states */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--text-muted);
  text-align: center;
}

.empty-state svg {
  opacity: 0.4;
  margin-bottom: 12px;
}

.empty-state p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

.empty-state span {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}

/* ============================================
   TAB DOCUMENTOS - Layout de 2 paneles
   ============================================ */
.documents-tab {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Summary bar */
.documents-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

.summary-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.summary-info svg {
  color: var(--accent);
}

.summary-count {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.summary-hint {
  font-size: 12px;
  color: var(--text-muted);
  padding-left: 12px;
  border-left: 1px solid var(--border-light);
}

.documents-panels {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  flex: 1 1;
  min-height: 0;
}

/* Panel de documentos */
.documents-panel {
  min-height: 400px;
}

/* Document list header (sorting) */
.doc-list-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--bg-sunken);
  border-bottom: 1px solid var(--border-light);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
}

.header-cell {
  background: none;
  border: none;
  font: inherit;
  color: inherit;
  cursor: default;
  padding: 0;
}

.header-cell.sortable {
  cursor: pointer;
  transition: color 0.15s;
}

.header-cell.sortable:hover {
  color: var(--accent);
}

/* Column widths - shared between header and data rows */
.header-cell.check-cell,
.doc-cell.check-cell {
  width: 36px;
  flex-shrink: 0;
}

.header-cell.name-cell,
.doc-cell.name-cell {
  flex: 1 1;
  min-width: 0;
  text-align: left;
}

.header-cell.size-cell,
.doc-cell.size-cell {
  width: 80px;
  flex-shrink: 0;
  text-align: right;
}

.header-cell.date-cell,
.doc-cell.date-cell {
  width: 110px;
  flex-shrink: 0;
  text-align: left;
}

.header-cell.status-cell,
.doc-cell.status-cell {
  width: 90px;
  flex-shrink: 0;
  text-align: left;
}

.header-cell.preview-cell,
.doc-cell.preview-cell {
  width: 36px;
  flex-shrink: 0;
}

.header-cell.actions-cell,
.doc-cell.actions-cell {
  width: 36px;
  flex-shrink: 0;
}

/* Doc item cell specific styles */
.doc-cell {
  display: flex;
  align-items: center;
}

.doc-cell.check-cell {
  justify-content: center;
}

.doc-cell.name-cell {
  gap: 10px;
  cursor: pointer;
  overflow: hidden;
}

.doc-cell.name-cell:hover .doc-name {
  color: var(--accent);
}

.doc-cell.size-cell {
  justify-content: flex-end;
  color: var(--text-secondary);
  font-size: 12px;
}

.doc-cell.preview-cell,
.doc-cell.actions-cell {
  justify-content: center;
}

/* Folder styles */
.folder-breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  background: var(--bg-sunken);
  border-bottom: 1px solid var(--border-light);
  flex-wrap: wrap;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 13px;
  transition: all 0.15s;
}

.breadcrumb-item:hover {
  background: var(--bg-surface);
  color: var(--accent);
}

.breadcrumb-item.active {
  color: var(--text-primary);
  font-weight: 500;
}

.breadcrumb-item.drag-over {
  background: var(--accent);
  color: white;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.4);
}

.breadcrumb-separator {
  color: var(--text-muted);
}

.doc-item.is-folder {
  background: var(--bg-sunken);
}

.doc-item.is-folder:hover {
  background: var(--bg-surface);
}

.doc-item.drag-over {
  background: rgba(99, 102, 241, 0.1);
  border-color: var(--accent);
}

.folder-icon {
  color: #f59e0b;
}

.status-badge.folder {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.btn-icon.preview,
.btn-icon.delete {
  opacity: 1;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  color: var(--text-muted);
}

.btn-icon.preview:hover {
  color: var(--accent);
  background: var(--accent-light);
}

.doc-date {
  font-size: 11px;
  color: var(--text-muted);
}

/* File icon emoji */
.file-icon-emoji {
  font-size: 18px;
  flex-shrink: 0;
}

.file-icon-emoji.large {
  font-size: 28px;
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.status-badge.ready {
  background: var(--success-bg);
  color: var(--success);
}

.status-badge.processing {
  background: var(--warning-bg);
  color: #b06d00;
}

.status-badge.pending {
  background: var(--bg-sunken);
  color: var(--text-muted);
}

.status-badge.error {
  background: var(--error-bg);
  color: var(--error);
}

/* Config panels (template + instructions) */
.config-panels {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.instructions-panel {
  min-height: 200px;
}

.panel-title h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.doc-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.doc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--bg-sunken);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.15s;
}

.doc-item:hover {
  background: var(--bg-surface);
  border-color: var(--border-medium);
  box-shadow: var(--shadow-sm);
}

.doc-item:hover .btn-icon {
  opacity: 1;
}

.doc-item.selected {
  background: var(--accent-light);
  border-color: var(--accent);
}

.doc-item.processing {
  opacity: 0.6;
  cursor: default;
}

.doc-item.error {
  background: var(--error-bg);
  border-color: #f5c6c6;
}

.doc-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.doc-item-left input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--accent);
  cursor: pointer;
}

.status-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.status-dot.ready { color: var(--success); }
.status-dot.processing { color: var(--warning); }
.status-dot.error { color: var(--error); }

.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--border-light);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  flex-shrink: 0;
}

.file-icon.pdf { background: #fce8e6; color: #c5221f; }
.file-icon.docx, .file-icon.doc { background: #e8f0fe; color: #1a73e8; }
.file-icon.xlsx, .file-icon.xls { background: #e6f4ea; color: #1e8e3e; }
.file-icon.pptx, .file-icon.ppt { background: #fef7e0; color: #f9ab00; }
.file-icon.txt { background: #f1f3f4; color: #5f6368; }
.file-icon.jpg, .file-icon.jpeg, .file-icon.png { background: #f3e8fd; color: #8430ce; }

.doc-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doc-item.selected .doc-name {
  color: var(--accent-dark);
}

.doc-item-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-label {
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
}

.status-label.processing {
  background: var(--warning-bg);
  color: #b06d00;
}

.status-label.error {
  background: var(--error-bg);
  color: var(--error);
}

.selection-count {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--accent);
}

/* Panel de plantilla */
.template-panel {
  min-height: 300px;
}

.drop-zone {
  min-height: 200px;
  border: 2px dashed var(--border-medium);
  border-radius: var(--radius-md);
  background: var(--bg-sunken);
  transition: all 0.2s;
}

.drop-zone.drag-over {
  border-color: var(--accent);
  background: var(--accent-light);
}

.drop-zone.has-template {
  border-style: solid;
  border-color: var(--border-light);
  background: var(--bg-surface);
}

.template-empty {
  padding: 48px 20px;
}

.drop-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  background: var(--border-light);
  border-radius: 50%;
  color: var(--text-muted);
}

.template-doc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: linear-gradient(135deg, #e8f0fe 0%, #f8faff 100%);
  border: 1px solid #c2d9f7;
  border-radius: var(--radius-md);
  margin: 8px;
}

.template-doc-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.template-doc-info .file-icon {
  width: 44px;
  height: 44px;
}

.template-doc-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.template-doc-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.template-doc-hint {
  font-size: 11px;
  color: var(--text-secondary);
}

/* Action bar */
.documents-action-bar {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
}

/* ============================================
   TAB WORKFLOW (TAREAS)
   ============================================ */
.workflow-tab,
.workflow-container,
.workflow-canvas {
  width: 100% !important;
  height: calc(100vh - 180px) !important;
  display: block !important;
}

.workflow-canvas {
  background-color: #f8fafc;
  background-image: radial-gradient(circle, #cbd5e1 1px, transparent 1px);
  background-size: 24px 24px;
  border: 2px dashed #94a3b8;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}

.workflow-connections {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.workflow-connections line {
  pointer-events: stroke;
}

.workflow-connections g:hover line {
  stroke: var(--error);
}

.workflow-node {
  position: absolute;
  width: 150px;
  background: var(--bg-surface);
  border: 2px solid var(--node-color);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  transition: box-shadow 0.15s, transform 0.1s;
}

.workflow-node:hover {
  box-shadow: var(--shadow-md);
}

.workflow-node.selected {
  box-shadow: 0 0 0 3px var(--node-color);
}

.workflow-node.pending .node-header {
  opacity: 0.7;
}

.workflow-node.running {
  animation: pulse 1.5s infinite;
}

.workflow-node.completed {
  border-color: var(--success);
}

.workflow-node.completed .node-header::after {
  content: '✓';
  margin-left: auto;
  color: var(--success);
  font-weight: bold;
}

.workflow-node.error {
  border-color: var(--error);
}

.workflow-node.error .node-header::after {
  content: '✗';
  margin-left: auto;
  color: var(--error);
  font-weight: bold;
}

@keyframes pulse {
  0%, 100% { box-shadow: var(--shadow-sm); }
  50% { box-shadow: 0 0 0 4px var(--accent-light); }
}

.node-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: linear-gradient(180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 100%);
  border-bottom: 1px solid var(--border-light);
}

.node-icon {
  font-size: 18px;
}

.node-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.node-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  cursor: pointer;
  opacity: 0;
  transition: all 0.15s;
}

.workflow-node:hover .node-delete {
  opacity: 1;
}

.node-delete:hover {
  background: var(--error-bg);
  color: var(--error);
}

.node-label {
  padding: 8px 12px;
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.node-connectors {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
}

.connector {
  width: 12px;
  height: 12px;
  background: var(--bg-surface);
  border: 2px solid var(--border-medium);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.15s;
}

.connector:hover {
  border-color: var(--accent);
  background: var(--accent-light);
}

.connector.output {
  background: var(--node-color);
  border-color: var(--node-color);
}

.workflow-empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: var(--text-muted);
  pointer-events: none;
}

.workflow-empty h3 {
  margin: 16px 0 8px;
  color: var(--text-primary);
  font-size: 18px;
}

.workflow-empty p {
  margin: 0;
  font-size: 14px;
}

/* Panel de configuración del nodo */
.node-config-panel {
  width: 300px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.config-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: var(--bg-sunken);
  border-bottom: 1px solid var(--border-light);
  font-weight: 600;
  flex-wrap: wrap;
}

.node-type-badge {
  margin-left: auto;
  font-size: 10px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.node-type-badge.initial {
  background: var(--accent-light);
  color: var(--accent);
}

.node-type-badge.chained {
  background: #f0fdf4;
  color: #16a34a;
}

.input-source {
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  border: 1px solid #bbf7d0;
  border-radius: var(--radius-md);
  padding: 12px;
  margin-bottom: 4px;
}

.input-source label {
  color: #16a34a;
  font-weight: 600;
  margin-bottom: 8px;
}

.source-nodes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.source-node-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  border: 1px solid #86efac;
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  color: #166534;
}

.source-node-tag .source-icon {
  font-size: 14px;
}

.config-icon {
  font-size: 20px;
}

.config-body {
  padding: 16px;
}

.config-field {
  margin-bottom: 16px;
}

.config-field:last-child {
  margin-bottom: 0;
}

.config-field label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.config-field input[type="text"],
.config-field textarea {
  width: 100%;
  padding: 10px 12px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  font-size: 13px;
  color: var(--text-primary);
  resize: vertical;
}

.config-field input:focus,
.config-field textarea:focus {
  outline: none;
  border-color: var(--accent);
  background: var(--bg-surface);
}

.config-docs-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  background: var(--bg-sunken);
}

.config-doc-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-light);
  font-size: 13px;
  color: #1a1d21;
  transition: background 0.15s;
}

.config-doc-item:last-child {
  border-bottom: none;
}

.config-doc-item:hover {
  background: var(--bg-surface);
}

.config-doc-item.selected {
  background: var(--accent-light);
}

.config-doc-item input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.config-doc-item span {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1a1d21;
}

.config-docs-list .no-docs {
  padding: 16px;
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
}

/* Documentos especiales (modelo e instrucciones) */
.special-docs-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.special-doc-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.15s;
}

.special-doc-option:hover:not(.unavailable) {
  background: var(--bg-surface);
  border-color: var(--accent);
}

.special-doc-option.active {
  background: var(--accent-light);
  border-color: var(--accent);
}

.special-doc-option.unavailable {
  opacity: 0.5;
  cursor: default;
}

.special-doc-option input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
}

.special-doc-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.special-doc-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}

.special-doc-name {
  font-size: 11px;
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.special-doc-option.active .special-doc-label {
  color: var(--accent);
}

.special-doc-option.unavailable .special-doc-label {
  color: var(--text-muted);
}

/* Barra de acciones del workflow */
.workflow-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 0;
}

.workflow-info {
  margin-right: auto;
  font-size: 13px;
  color: var(--text-secondary);
}

.workflow-warning {
  color: var(--warning);
  font-weight: 500;
}

.draggable-agent {
  cursor: grab;
}

.draggable-agent:active {
  cursor: grabbing;
}

.form-row {
  margin-bottom: 24px;
}

.form-row label {
  display: block;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.form-row.inline {
  display: flex;
  gap: 16px;
}

.form-row .field {
  flex: 1 1;
}

.form-row input[type="text"],
.form-row textarea {
  width: 100%;
  padding: 12px 16px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  font-size: 14px;
  color: var(--text-primary);
  transition: all 0.15s;
  resize: vertical;
}

.form-row input[type="text"]:focus,
.form-row textarea:focus {
  outline: none;
  border-color: var(--accent);
  background: var(--bg-surface);
  box-shadow: 0 0 0 3px var(--accent-light);
}

.agent-selector {
  display: flex;
  gap: 12px;
}

.agent-option {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 16px;
  background: var(--bg-sunken);
  border: 2px solid var(--border-light);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.agent-option:hover {
  border-color: var(--border-medium);
  background: var(--bg-surface);
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.agent-option.selected {
  border-color: var(--agent-color, var(--accent));
  background: var(--bg-surface);
  color: var(--text-primary);
  box-shadow: var(--shadow-md);
}

.agent-option .agent-icon {
  font-size: 28px;
}

.docs-selector {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding: 16px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
}

.doc-checkbox {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  transition: all 0.15s;
}

.doc-checkbox:hover {
  border-color: var(--border-medium);
  box-shadow: var(--shadow-sm);
}

.doc-checkbox input {
  width: 16px;
  height: 16px;
  accent-color: var(--accent);
}

.doc-checkbox label {
  flex: 1 1;
  margin: 0;
  font-size: 13px;
  color: var(--text-primary);
  cursor: pointer;
}

.template-btn {
  padding: 6px 12px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  font-size: 11px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.template-btn:hover {
  background: var(--border-light);
}

.template-btn.active {
  background: var(--warning-bg);
  border-color: var(--warning);
  color: #7c4d00;
}

.no-docs {
  font-size: 13px;
  color: var(--text-muted);
  text-align: center;
  padding: 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  background: var(--bg-sunken);
  border-top: 1px solid var(--border-light);
}

/* Cola de tareas */
.task-queue {
  margin-top: 24px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.queue-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);
  border-bottom: 1px solid var(--border-light);
}

.task-queue h4 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.queue-header .btn {
  padding: 8px 16px;
  font-size: 13px;
}

.queue-list {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.queue-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  transition: all 0.15s;
}

.queue-item:hover {
  background: var(--bg-surface);
  box-shadow: var(--shadow-sm);
}

.queue-number {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-light);
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
}

.queue-icon {
  font-size: 18px;
}

.queue-label {
  flex: 1 1;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}

.queue-agent {
  font-size: 12px;
  color: var(--text-secondary);
  padding: 4px 10px;
  background: var(--border-light);
  border-radius: var(--radius-sm);
}

.queue-remove {
  padding: 6px;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.15s;
  border-radius: var(--radius-sm);
}

.queue-remove:hover {
  color: var(--error);
  background: var(--error-bg);
}

/* ============================================
   TAB EDITOR
   ============================================ */
.editor-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
}

.execution-status {
  padding: 16px 20px;
  background: var(--accent-light);
  border: 1px solid #c2d9f7;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

.status-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 13px;
}

.status-text {
  color: var(--accent-dark);
  font-weight: 500;
}

.status-progress {
  color: var(--accent);
  font-weight: 600;
}

.progress-bar {
  height: 6px;
  background: #c2d9f7;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent) 0%, #4d9fff 100%);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.editor-content {
  flex: 1 1;
  padding: 28px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow-y: auto;
  min-height: 400px;
}

.editor-edit-mode {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
}

.edit-textarea {
  flex: 1 1;
  width: 100%;
  min-height: 400px;
  padding: 20px;
  border: 1px solid var(--border-medium);
  border-radius: var(--radius-md);
  font-family: inherit;
  font-size: 14px;
  line-height: 1.75;
  color: var(--text-primary);
  resize: vertical;
  background: var(--bg-sunken);
}

.edit-textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-light);
}

.edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-light);
}

.edit-export-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-btn:hover {
  background: var(--accent-light);
  color: var(--accent);
  border-color: var(--accent);
}

.output-text {
  font-size: 14px;
  line-height: 1.75;
  color: var(--text-primary);
}

.output-text h1, .output-text h2, .output-text h3 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: var(--text-primary);
}

.output-text p {
  margin-bottom: 1em;
}

.output-text p:empty {
  display: none;
}

.output-text > *:last-child {
  margin-bottom: 0;
}

.output-text ul, .output-text ol {
  margin-bottom: 1em;
  padding-left: 1.5em;
}

.citation {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  margin: 2px 4px 2px 0;
  background: var(--accent-light);
  border-radius: var(--radius-sm);
  font-size: 11px;
  font-weight: 500;
  color: var(--accent);
  vertical-align: middle;
  cursor: help;
}

.cursor {
  display: inline-block;
  animation: blink 1s infinite;
  color: var(--accent);
  font-weight: bold;
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.editor-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--text-muted);
}

.editor-empty svg {
  margin-bottom: 16px;
  opacity: 0.4;
}

.editor-empty p {
  font-size: 14px;
  color: var(--text-secondary);
}

.editor-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

.refine-actions,
.export-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.refine-actions span {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-right: 4px;
}

.editor-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.15s;
}

.editor-actions button:hover {
  background: var(--bg-surface);
  border-color: var(--border-medium);
  box-shadow: var(--shadow-sm);
}

/* ============================================
   TAB PREVIEW
   ============================================ */
.preview-tab {
  height: 100%;
}

.preview-content {
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 36px;
}

.preview-section {
  margin-bottom: 36px;
  padding-bottom: 36px;
  border-bottom: 1px solid var(--border-light);
}

.preview-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.preview-section h3 {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  color: var(--text-muted);
}

.preview-empty svg {
  margin-bottom: 16px;
  opacity: 0.4;
}

/* ============================================
   SIDEBAR DERECHA
   ============================================ */
.sidebar-right {
  width: 300px;
  min-width: 300px;
  height: 100vh;
  position: sticky;
  top: 0;
  background: var(--bg-surface);
  border-left: 1px solid var(--border-light);
  box-shadow: -2px 0 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  transition: width 0.2s, min-width 0.2s;
}

.sidebar-right.collapsed {
  width: 20px;
  min-width: 20px;
  border: none;
  padding: 0;
}

.panel-toggle {
  position: absolute;
  top: 20px;
  left: -14px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  transition: all 0.15s;
  box-shadow: var(--shadow-sm);
}

.panel-toggle:hover {
  background: var(--bg-sunken);
  box-shadow: var(--shadow-md);
}

.sidebar-right .panel-header {
  padding: 20px 24px;
  background: transparent;
  border-bottom: 1px solid var(--border-light);
}

.panel-section {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-light);
}

.panel-section h4 {
  margin: 0 0 14px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.agent-card {
  padding: 14px 16px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  margin-bottom: 10px;
}

.agent-card.active {
  background: var(--accent-light);
  border-color: #c2d9f7;
}

.agent-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.agent-card-header .agent-icon {
  font-size: 18px;
}

.agent-card-header .agent-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.agent-card-task {
  font-size: 12px;
  color: var(--text-primary);
  margin-bottom: 6px;
}

.agent-card-status {
  font-size: 11px;
  color: var(--text-secondary);
  margin-bottom: 10px;
}

.agent-progress {
  height: 4px;
  background: var(--border-light);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 10px;
}

.agent-progress-fill {
  height: 100%;
  background: var(--accent);
  border-radius: 2px;
  transition: width 0.3s;
}

.agent-card-meta {
  display: flex;
  gap: 14px;
  font-size: 11px;
  color: var(--text-muted);
}

.agent-card-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.queue-mini {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.queue-mini-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bg-sunken);
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--text-primary);
}

.queue-mini-more {
  font-size: 11px;
  color: var(--text-muted);
  text-align: center;
  padding: 6px;
}

.completed-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.completed-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--success-bg);
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--success);
}

.completed-item svg {
  flex-shrink: 0;
}

.completed-item span:first-of-type {
  flex: 1 1;
}

.completed-tokens {
  font-size: 11px;
  color: var(--text-secondary);
}

.panel-section.stats {
  border-bottom: none;
}

.stat-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 13px;
  border-bottom: 1px solid var(--border-light);
}

.stat-row:last-child {
  border-bottom: none;
}

.stat-row span:first-child {
  color: var(--text-secondary);
}

.stat-row span:last-child {
  font-weight: 600;
  color: var(--text-primary);
}

/* Tiempo de sesión - footer de sidebar */
.session-time-footer {
  margin-top: auto;
  padding: 12px 16px;
  border-top: 1px solid var(--border-light);
  background: var(--bg-sunken);
}

.session-time-row {
  display: flex;
  gap: 16px;
}

.session-time-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.session-time-label {
  font-size: 10px;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.session-time-value {
  font-family: 'SF Mono', 'Consolas', monospace;
  font-size: 14px;
  font-weight: 600;
}

.session-time-value.current {
  color: var(--accent);
}

.session-time-value.total {
  color: var(--text-primary);
}

.session-time-history {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-light);
}

.session-time-history-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 4px 0;
  font-size: 11px;
  color: var(--text-secondary);
  cursor: pointer;
  width: 100%;
}

.session-time-history-toggle:hover {
  color: var(--text-primary);
}

.session-time-entries {
  margin-top: 6px;
  max-height: 120px;
  overflow-y: auto;
}

.session-time-entry {
  display: flex;
  gap: 8px;
  padding: 4px 0;
  font-size: 11px;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-light);
}

.session-time-entry:last-child {
  border-bottom: none;
}

.session-time-entry .entry-date {
  color: var(--text-tertiary);
  min-width: 40px;
}

.session-time-entry .entry-time {
  color: var(--text-secondary);
  min-width: 45px;
}

.session-time-entry .entry-duration {
  margin-left: auto;
  font-family: 'SF Mono', 'Consolas', monospace;
  color: var(--text-primary);
}

/* ============================================
   ANIMACIONES
   ============================================ */
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 1400px) {
  .documents-panels {
    grid-template-columns: 1fr 280px;
  }
}

@media (max-width: 1200px) {
  .sidebar-right {
    width: 260px;
    min-width: 260px;
  }

  .documents-panels {
    grid-template-columns: 1fr;
  }

  .template-panel {
    min-height: 200px;
  }
}

@media (max-width: 1024px) {
  .sidebar-left {
    width: 220px;
    min-width: 220px;
  }

  .sidebar-right.collapsed {
    width: 0;
    min-width: 0;
    border: none;
  }
}

/* ============================================
   TOAST NOTIFICATIONS
   ============================================ */
.toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  font-size: 14px;
  color: var(--text-primary);
  animation: slideIn 0.3s ease;
  min-width: 280px;
  max-width: 400px;
}

.toast svg {
  flex-shrink: 0;
}

.toast-success {
  background: var(--success-bg);
  border-color: #a8dab5;
  color: var(--success);
}

.toast-success svg {
  color: var(--success);
}

.toast-error {
  background: var(--error-bg);
  border-color: #f5c6c6;
  color: var(--error);
}

.toast-error svg {
  color: var(--error);
}

.toast-info {
  background: var(--accent-light);
  border-color: #c2d9f7;
  color: var(--accent);
}

.toast-info svg {
  color: var(--accent);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ============================================
   BARRA DE VERSIONES
   ============================================ */
.versions-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  margin-bottom: 16px;
}

.versions-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.version-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.15s;
  color: var(--text-secondary);
}

.version-nav-btn:hover:not(:disabled) {
  background: var(--accent-light);
  border-color: var(--accent);
  color: var(--accent);
}

.version-nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.version-indicator {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  min-width: 120px;
  text-align: center;
}

.versions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.version-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 14px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.15s;
}

.version-chip:hover:not(:disabled) {
  background: var(--bg-surface);
  border-color: var(--border-medium);
}

.version-chip.active {
  background: var(--accent-light);
  border-color: var(--accent);
}

.version-chip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.version-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
}

.version-chip.active .version-label {
  color: var(--accent);
}

.version-time {
  font-size: 10px;
  color: var(--text-muted);
  margin-top: 2px;
}

/* Preview versions */
.preview-versions-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  margin-bottom: 16px;
}

.preview-versions-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

.preview-versions-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.preview-version-chip {
  padding: 6px 14px;
  background: var(--bg-sunken);
  border: 1px solid var(--border-light);
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.preview-version-chip:hover {
  background: var(--bg-surface);
  border-color: var(--border-medium);
  color: var(--text-primary);
}

.preview-version-chip.active {
  background: var(--accent);
  border-color: var(--accent);
  color: white;
}

.preview-header {
  padding: 12px 20px;
  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);
  border-bottom: 1px solid var(--border-light);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.preview-version-info {
  font-size: 12px;
  color: var(--text-secondary);
}

.preview-body {
  padding: 28px;
}

/* ============================================
   PREVIEW MODAL
   ============================================ */
.preview-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 40px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.preview-modal {
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  background: var(--bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.preview-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-light);
  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.preview-modal-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.preview-modal-title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.preview-modal-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 12px;
  color: var(--text-muted);
}

.preview-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.preview-modal-close:hover {
  background: var(--error-bg);
  border-color: var(--error);
  color: var(--error);
}

.preview-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

.preview-modal-content {
  font-size: 14px;
  line-height: 1.75;
  color: var(--text-primary);
  white-space: pre-wrap;
  word-wrap: break-word;
}

.preview-modal-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: var(--text-muted);
}

.preview-modal-empty svg {
  margin-bottom: 16px;
  opacity: 0.4;
}

.preview-modal-empty p {
  font-size: 14px;
  color: var(--text-secondary);
}

/* ============================================
   AGENTS TAB
   ============================================ */
.agents-tab {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.agents-section {
  background: var(--bg-surface);
  border-radius: var(--radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
}

.agents-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 0;
  background: transparent;
  border: none;
  color: inherit;
  text-transform: none;
  letter-spacing: normal;
  font-size: inherit;
}

.agents-section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 6px 0;
}

.agents-section .section-description {
  font-size: 13px;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.5;
}

/* Base Agents Grid */
.base-agents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 20px;
}

.base-agent-card {
  background: var(--bg-surface);
  border: 2px solid var(--border-light);
  border-radius: var(--radius-md);
  padding: 20px;
  transition: all 0.2s;
}

.base-agent-card:hover {
  border-color: inherit;
  box-shadow: var(--shadow-md);
}

.base-agent-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.base-agent-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.base-agent-info h4 {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.base-agent-type {
  font-size: 12px;
  color: var(--text-muted);
}

.base-agent-description {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.base-agent-card .btn {
  width: 100%;
}

/* Custom Agents List */
.custom-agents-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.custom-agent-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: var(--bg-sunken);
  border-radius: var(--radius-md);
  transition: all 0.15s;
}

.custom-agent-item:hover {
  background: var(--accent-light);
}

.custom-agent-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.custom-agent-info {
  flex: 1 1;
  min-width: 0;
}

.custom-agent-name {
  font-weight: 600;
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 3px;
}

.custom-agent-meta {
  font-size: 12px;
  color: var(--text-muted);
}

.custom-agent-item.clickable {
  cursor: pointer;
}

.custom-agent-item.clickable:hover {
  background: var(--accent-light);
}

.custom-agent-arrow {
  color: var(--text-muted);
  flex-shrink: 0;
}

/* Empty State */
.agents-section .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  text-align: center;
  color: var(--text-muted);
}

.agents-section .empty-state svg {
  opacity: 0.4;
  margin-bottom: 16px;
}

.agents-section .empty-state p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
}

.agents-section .empty-state span {
  font-size: 13px;
  margin-top: 6px;
}

/* ============================================
   AGENT MODAL
   ============================================ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 40px;
  animation: fadeIn 0.2s ease;
}

.agent-modal {
  width: 100%;
  max-width: 520px;
  background: var(--bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  animation: slideUp 0.3s ease;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-light);
}

.modal-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--text-primary);
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-light);
  background: var(--bg-sunken);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

.modal-footer-right {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.btn.danger {
  background: transparent;
  border: 1px solid var(--error);
  color: var(--error);
}

.btn.danger:hover {
  background: var(--error-bg);
}

/* Form Elements */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

.form-group input,
.form-group textarea,
.form-group select {
  padding: 10px 12px;
  border: 1px solid var(--border-medium);
  border-radius: var(--radius-sm);
  font-size: 14px;
  background: var(--bg-surface);
  color: var(--text-primary);
  transition: all 0.15s;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-light);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
  line-height: 1.5;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Base Agent Selector */
.base-agent-selector {
  display: flex;
  gap: 12px;
}

.base-agent-option {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  background: var(--bg-sunken);
  border: 2px solid transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.15s;
}

.base-agent-option:hover {
  background: var(--accent-light);
}

.base-agent-option.selected {
  background: var(--accent-light);
}

.base-agent-option .option-icon {
  font-size: 28px;
}

.base-agent-option .option-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}

/* ============================================
   SIDEBAR AGENTS
   ============================================ */
.agent-item {
  position: relative;
  border-left: 3px solid var(--agent-color, #6366f1);
  padding-left: 10px !important;
}

.agent-item .agent-icon {
  font-size: 15px;
}

.agent-item.custom {
  opacity: 0.9;
}

.custom-badge {
  font-size: 11px;
  font-weight: 600;
  color: var(--agent-color);
  margin-left: auto;
}

.custom-agents-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px 6px 12px;
  margin-top: 4px;
}

.custom-agents-divider span {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #6b7280;
}

.custom-agents-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}

.draggable-agent {
  cursor: grab;
}

.draggable-agent:active {
  cursor: grabbing;
}

/* ============================================
   OUTPUT TABS (Pestañas por workflow/agente)
   ============================================ */
.output-tabs {
  display: flex;
  gap: 8px;
  padding: 12px 20px;
  background: var(--bg-sunken);
  border-bottom: 1px solid var(--border-light);
  overflow-x: auto;
}

.output-tab {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: var(--bg-surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.output-tab:hover {
  border-color: var(--border-medium);
  box-shadow: var(--shadow-sm);
}

.output-tab.active {
  background: var(--accent-light);
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--accent-light);
}

.output-tab-icons {
  display: flex;
  align-items: center;
  gap: 4px;
}

.output-tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  font-size: 14px;
}

.output-tab-arrow {
  color: var(--text-muted);
  font-size: 12px;
  margin: 0 2px;
}

.output-tab-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}

.output-tab-versions {
  font-size: 11px;
  background: var(--accent);
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 6px;
}

.output-tab.active .output-tab-label {
  color: var(--accent-dark);
}

/* ============================================
   WORKFLOW INFO BAR
   ============================================ */

.workflow-info-bar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(135deg, var(--bg-elevated) 0%, var(--bg-card) 100%);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  margin-bottom: 12px;
  font-size: 13px;
}

.workflow-info-agents,
.workflow-info-docs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.workflow-info-label {
  color: var(--text-muted);
  font-weight: 500;
  min-width: 80px;
}

.workflow-info-agent {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: var(--bg-base);
  border: 1px solid var(--border-light);
  border-left-width: 3px;
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--text-primary);
}

.workflow-info-agent .agent-icon {
  font-size: 14px;
}

.workflow-info-doc {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: var(--accent-bg);
  border-radius: var(--radius-sm);
  font-size: 11px;
  color: var(--accent-dark);
}

.workflow-info-doc svg {
  opacity: 0.7;
}

/* ============================================
   CHAT TAB - RAG Document Chat
   ============================================ */

.chat-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-base);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.chat-empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  gap: 12px;
  background: var(--bg-surface);
}

.chat-layout {
  display: flex;
  height: 100%;
  gap: 0;
}

/* Panel lateral de documentos */
.chat-docs-panel {
  background: var(--bg-surface);
  border-right: 1px solid var(--border-light);
  display: flex;
  flex-direction: column;
  transition: width 0.2s ease;
  overflow: hidden;
}

.chat-docs-panel.expanded {
  width: 260px;
  min-width: 260px;
}

.chat-docs-panel.collapsed {
  width: 48px;
  min-width: 48px;
}

.chat-docs-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-light);
  transition: background 0.15s ease;
  width: 100%;
  text-align: left;
}

.chat-docs-toggle:hover {
  background: var(--bg-sunken);
}

.chat-docs-panel.collapsed .chat-docs-toggle {
  justify-content: center;
  padding: 14px 8px;
}

.chat-docs-panel.collapsed .chat-docs-toggle span:not(.chat-docs-count) {
  display: none;
}

.chat-docs-panel.collapsed .chat-docs-count {
  display: none;
}

.chat-docs-count {
  margin-left: auto;
  font-size: 11px;
  font-weight: 500;
  color: var(--accent);
  background: var(--accent-light);
  padding: 2px 8px;
  border-radius: 10px;
}

.chat-docs-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}

.chat-docs-empty {
  padding: 20px;
  text-align: center;
  color: var(--text-muted);
  font-size: 12px;
}

.chat-docs-actions {
  display: flex;
  gap: 6px;
  padding: 4px 4px 8px;
  border-bottom: 1px solid var(--border-light);
  margin-bottom: 8px;
}

.chat-docs-select-all,
.chat-docs-clear {
  flex: 1 1;
  padding: 6px 8px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.chat-docs-select-all {
  background: var(--accent-light);
  color: var(--accent);
}

.chat-docs-select-all:hover {
  background: var(--accent);
  color: white;
}

.chat-docs-clear {
  background: var(--bg-sunken);
  color: var(--text-secondary);
}

.chat-docs-clear:hover {
  background: var(--error-bg);
  color: var(--error);
}

.chat-doc-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.15s ease;
  margin-bottom: 2px;
}

.chat-doc-item:hover {
  background: var(--bg-sunken);
}

.chat-doc-item.selected {
  background: var(--accent-light);
}

.chat-doc-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--accent);
  cursor: pointer;
}

.chat-doc-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.chat-doc-name {
  font-size: 12px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Area principal del chat */
.chat-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, var(--bg-sunken) 0%, var(--bg-surface) 100%);
  min-width: 0;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chat-welcome {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
}

.chat-welcome-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-light) 0%, var(--accent) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: var(--shadow-md);
}

.chat-welcome h3 {
  margin: 0;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 18px;
}

.chat-welcome p {
  margin: 0;
  max-width: 360px;
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.chat-welcome-hint,
.chat-welcome-ready {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 13px;
  margin-top: 8px;
}

.chat-welcome-hint {
  background: var(--warning-bg);
  color: var(--warning);
}

.chat-welcome-ready {
  background: var(--success-bg);
  color: var(--success);
}

/* Mensajes */
.chat-message {
  display: flex;
  gap: 12px;
  max-width: 80%;
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chat-message.user {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.chat-message-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--bg-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.chat-message.user .chat-message-avatar {
  background: var(--accent-light);
}

.chat-message-bubble {
  background: var(--bg-surface);
  padding: 14px 18px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.6;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
}

.chat-message.user .chat-message-bubble {
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
  color: white;
  border: none;
}

.chat-message.user .chat-message-bubble p {
  margin: 0;
}

.chat-message.assistant .chat-message-bubble p:first-child {
  margin-top: 0;
}

.chat-message.assistant .chat-message-bubble p:last-child {
  margin-bottom: 0;
}

.chat-message.error .chat-message-bubble {
  background: var(--error-bg);
  color: var(--error);
  border-color: var(--error);
}

.chat-message-bubble.loading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-secondary);
}

.chat-typing {
  display: flex;
  gap: 4px;
}

.chat-typing span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent);
  animation: typingBounce 1.4s infinite ease-in-out both;
}

.chat-typing span:nth-child(1) { animation-delay: -0.32s; }
.chat-typing span:nth-child(2) { animation-delay: -0.16s; }
.chat-typing span:nth-child(3) { animation-delay: 0s; }

@keyframes typingBounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Fuentes */
.chat-sources {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--border-light);
}

.chat-sources-label {
  display: block;
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.chat-sources-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chat-source-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: var(--bg-sunken);
  border-radius: 12px;
  font-size: 11px;
  color: var(--text-secondary);
  border: 1px solid var(--border-light);
}

/* Input area */
.chat-input-area {
  padding: 16px 24px;
  background: var(--bg-surface);
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 12px;
  align-items: center;
}

.chat-new-btn {
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-light);
  background: var(--bg-surface);
  color: var(--text-secondary);
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.chat-new-btn:hover {
  background: var(--bg-sunken);
  color: var(--text-primary);
}

.chat-input-wrapper {
  flex: 1 1;
  position: relative;
}

.chat-input {
  width: 100%;
  padding: 12px 18px;
  border: 2px solid var(--border-light);
  border-radius: 24px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
  background: var(--bg-surface);
}

.chat-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-light);
}

.chat-input:disabled {
  background: var(--bg-sunken);
  cursor: not-allowed;
}

.chat-input::placeholder {
  color: var(--text-muted);
}

.chat-send-btn {
  width: 44px;
  height: 44px;
  border: none;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
  color: white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  box-shadow: var(--shadow-md);
}

.chat-send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: var(--shadow-lg);
}

.chat-send-btn:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* ============================================
   SELECTION MENU - Menú flotante de selección
   ============================================ */
.selection-menu {
  z-index: 9999;
  background: var(--bg-elevated);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--border-light);
  animation: fadeInScale 0.15s ease-out;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -100%) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -100%) scale(1);
  }
}

.selection-menu-buttons {
  display: flex;
  gap: 4px;
  padding: 6px;
}

.selection-menu-buttons button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.selection-menu-buttons button:hover {
  background: var(--bg-sunken);
  color: var(--text-primary);
}

.selection-menu-buttons button.close-btn {
  padding: 8px;
  color: var(--text-muted);
}

.selection-menu-buttons button.close-btn:hover {
  background: var(--error-bg);
  color: var(--error);
}

.selection-menu-input {
  width: 320px;
  padding: 12px;
}

.selection-menu-input-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.selection-menu-input-header span {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.selection-menu-input-header button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.15s ease;
}

.selection-menu-input-header button:hover {
  background: var(--error-bg);
  color: var(--error);
}

.selection-menu-input textarea {
  width: 100%;
  min-height: 80px;
  padding: 10px 12px;
  border: 1px solid var(--border-medium);
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.15s ease;
}

.selection-menu-input textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-light);
}

.selection-menu-input textarea::placeholder {
  color: var(--text-muted);
}

.selection-menu-input-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.selection-menu-input-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.selection-menu-input-actions button:first-child {
  background: transparent;
  color: var(--text-secondary);
}

.selection-menu-input-actions button:first-child:hover {
  background: var(--bg-sunken);
  color: var(--text-primary);
}

.selection-menu-input-actions button.primary {
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
  color: white;
}

.selection-menu-input-actions button.primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.selection-menu-input-actions button.primary:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  transform: none;
}

/* Selection Menu - Result View */
.selection-menu-large {
  width: 480px;
  max-width: 90vw;
}

.selection-menu-result {
  padding: 16px;
}

.selection-menu-result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-light);
}

.selection-menu-result-header span {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.selection-menu-result-header button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.15s ease;
}

.selection-menu-result-header button:hover {
  background: var(--error-bg);
  color: var(--error);
}

.selection-menu-result-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
  background: var(--bg-sunken);
  border-radius: var(--radius-sm);
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-primary);
}

.selection-menu-result-content p {
  margin: 0 0 8px 0;
}

.selection-menu-result-content p:last-child {
  margin-bottom: 0;
}

.selection-menu-result-content code {
  background: var(--bg-elevated);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.selection-menu-result-content pre {
  background: var(--bg-elevated);
  padding: 12px;
  border-radius: var(--radius-sm);
  overflow-x: auto;
}

.selection-menu-result-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-light);
}

.selection-menu-result-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  background: var(--bg-sunken);
  color: var(--text-secondary);
}

.selection-menu-result-actions button:hover {
  background: var(--border-light);
  color: var(--text-primary);
}

.selection-menu-result-actions button.primary {
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
  color: white;
}

.selection-menu-result-actions button.primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkspacePage.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,cAAc;AACd;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;iDAEiD;AACjD;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,4CAA4C;EAC5C,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;;iDAEiD;AACjD;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wDAAwD;AACxD;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB,qBAAqB,EAAE;AAC3C,yBAAyB,qBAAqB,EAAE;AAChD,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,kDAAkD,mBAAmB,EAAE,cAAc,EAAE;;AAEvF;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;;;EAGE,sBAAsB;EACtB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uEAAuE;EACvE,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW,4BAA4B,EAAE;EACzC,MAAM,yCAAyC,EAAE;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uFAAuF;EACvF,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kEAAkE;EAClE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sCAAsC;EACtC,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;iDAEiD;AACjD;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iDAEiD;AACjD;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,6BAA6B;EAC7B,0CAA0C;EAC1C,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;;iDAEiD;AACjD;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;iDAEiD;AACjD;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,4CAA4C;EAC5C,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;EAGE,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,+EAA+E;EAC/E,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,qCAAqC;EACrC,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,MAAM;AACR;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;EAC5C,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gFAAgF;EAChF,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;EAC/E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,8EAA8E;EAC9E,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA,iCAAiC,uBAAuB,EAAE;AAC1D,iCAAiC,uBAAuB,EAAE;AAC1D,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8EAA8E;EAC9E,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,0CAA0C;EAC5C;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,8EAA8E;EAC9E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,8EAA8E;EAC9E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* ============================================\n   WORKSPACE - Modern Dashboard Layout\n   Con elevation, depth y layered UI\n   ============================================ */\n\n/* Variables */\n:root {\n  --bg-base: #f0f2f5;\n  --bg-surface: #ffffff;\n  --bg-elevated: #ffffff;\n  --bg-sunken: #f8f9fb;\n  --border-light: #e8eaed;\n  --border-medium: #dadce0;\n  --text-primary: #1a1d21;\n  --text-secondary: #5f6368;\n  --text-muted: #9aa0a6;\n  --accent: #1a73e8;\n  --accent-light: #e8f0fe;\n  --accent-dark: #1557b0;\n  --success: #1e8e3e;\n  --success-bg: #e6f4ea;\n  --warning: #f9ab00;\n  --warning-bg: #fef7e0;\n  --error: #d93025;\n  --error-bg: #fce8e6;\n  --shadow-sm: 0 1px 2px rgba(0,0,0,0.05);\n  --shadow-md: 0 2px 8px rgba(0,0,0,0.08);\n  --shadow-lg: 0 4px 16px rgba(0,0,0,0.12);\n  --shadow-xl: 0 8px 32px rgba(0,0,0,0.16);\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n}\n\n/* Layout principal */\n.workspace {\n  display: flex;\n  min-height: 100vh;\n  background: var(--bg-base);\n}\n\n/* ============================================\n   SIDEBAR IZQUIERDA\n   ============================================ */\n.sidebar-left {\n  width: 260px;\n  min-width: 260px;\n  height: 100vh;\n  position: sticky;\n  top: 0;\n  background: linear-gradient(180deg, #1a1d24 0%, #252830 100%);\n  color: #e4e6eb;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-lg);\n  z-index: 10;\n}\n\n.sidebar-sections {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.sidebar-logo svg {\n  color: #4d9fff;\n}\n\n.sidebar-section {\n  padding: 8px 12px;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 12px;\n  margin-bottom: 4px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: #9ca3af;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.section-header:hover {\n  background: rgba(255,255,255,0.04);\n  color: #e4e6eb;\n}\n\n.section-content {\n  padding: 0 4px;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: #b8bcc4;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.sidebar-item:hover {\n  background: rgba(255,255,255,0.06);\n  color: #ffffff;\n}\n\n.sidebar-item.active {\n  background: rgba(77, 159, 255, 0.15);\n  color: #4d9fff;\n}\n\n.item-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.5;\n}\n\n.sidebar-item.active .item-dot {\n  background: #4d9fff;\n  opacity: 1;\n}\n\n.item-text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.session-actions {\n  display: none;\n  align-items: center;\n  gap: 2px;\n}\n\n.sidebar-item:hover .session-actions {\n  display: flex;\n}\n\n.session-btn {\n  padding: 4px;\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.session-btn.edit:hover {\n  background: rgba(255,255,255,0.1);\n  color: #4d9fff;\n}\n\n.session-btn.delete:hover {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.session-edit-input {\n  flex: 1;\n  padding: 2px 6px;\n  background: rgba(255,255,255,0.1);\n  border: 1px solid #4d9fff;\n  border-radius: 4px;\n  color: #ffffff;\n  font-size: 13px;\n  outline: none;\n}\n\n.sidebar-item.new-item {\n  color: #4d9fff;\n  font-size: 12px;\n  opacity: 0.9;\n}\n\n.sidebar-item.agent-item {\n  position: relative;\n  padding-left: 18px;\n}\n\n.sidebar-item.agent-item::before {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 0;\n  background: var(--agent-color);\n  border-radius: 0 2px 2px 0;\n  transition: height 0.15s;\n}\n\n.sidebar-item.agent-item.active::before {\n  height: 22px;\n}\n\n.agent-icon {\n  font-size: 15px;\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding: 12px;\n  background: #15171c;\n  border-top: 1px solid rgba(255,255,255,0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 12px;\n  background: rgba(255,255,255,0.04);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: var(--radius-sm);\n  color: #9ca3af;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.footer-btn:hover {\n  background: rgba(255,255,255,0.08);\n  color: #e4e6eb;\n}\n\n.footer-brand {\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255,255,255,0.06);\n  font-size: 11px;\n  color: #6b7280;\n  text-align: center;\n}\n\n/* ============================================\n   AREA PRINCIPAL\n   ============================================ */\n.main-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  width: 100%;\n  background: var(--bg-base);\n}\n\n.main-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 28px;\n  height: 64px;\n  background: var(--bg-surface);\n  border-bottom: 1px solid var(--border-light);\n  box-shadow: var(--shadow-sm);\n  z-index: 5;\n}\n\n.tabs {\n  display: flex;\n  gap: 6px;\n  padding: 4px;\n  background: var(--bg-sunken);\n  border-radius: var(--radius-md);\n}\n\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  position: relative;\n}\n\n.tab:hover {\n  color: var(--text-primary);\n}\n\n.tab.active {\n  background: var(--bg-surface);\n  color: var(--accent);\n  box-shadow: var(--shadow-sm);\n}\n\n.tab-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 7px;\n  height: 7px;\n  background: var(--accent);\n  border-radius: 50%;\n}\n\n.tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  background: var(--border-light);\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.tab.active .tab-count {\n  background: var(--accent-light);\n  color: var(--accent);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.project-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.main-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 28px;\n  width: 100%;\n}\n\n/* ============================================\n   COMPONENTES COMUNES - Panels con depth\n   ============================================ */\n.panel {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.panel-header .btn-icon {\n  opacity: 1;\n  color: var(--text-secondary);\n}\n\n.panel-header .btn-icon:hover {\n  background: var(--accent-light);\n  color: var(--accent);\n}\n\n.panel-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.panel-title svg {\n  color: var(--text-secondary);\n}\n\n.panel-title h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.panel-title .badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  background: var(--accent-light);\n  border-radius: 11px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--accent);\n}\n\n.panel-body {\n  flex: 1;\n  padding: 16px;\n  overflow-y: auto;\n}\n\n.panel-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: var(--bg-sunken);\n  border-top: 1px solid var(--border-light);\n}\n\n/* Botones comunes */\n.btn-upload {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: var(--accent);\n  border: none;\n  border-radius: var(--radius-sm);\n  color: white;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  box-shadow: 0 2px 4px rgba(26, 115, 232, 0.3);\n}\n\n.btn-upload:hover {\n  background: var(--accent-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(26, 115, 232, 0.35);\n}\n\n.btn-upload input {\n  display: none;\n}\n\n.btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.15s;\n  opacity: 0;\n}\n\n.btn-icon.delete:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.btn-icon.remove {\n  opacity: 1;\n  background: var(--bg-sunken);\n}\n\n.btn-icon.remove:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.btn-text {\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn-text:hover {\n  background: var(--border-light);\n  color: var(--text-primary);\n}\n\n.btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn.primary {\n  background: var(--accent);\n  color: white;\n  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);\n}\n\n.btn.primary:hover:not(:disabled) {\n  background: var(--accent-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);\n}\n\n.btn.secondary {\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-medium);\n  color: var(--text-primary);\n}\n\n.btn.secondary:hover:not(:disabled) {\n  background: var(--border-light);\n}\n\n.btn.danger {\n  background: #dc2626;\n  border: none;\n  color: white;\n}\n\n.btn.danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.btn.large {\n  padding: 14px 28px;\n  font-size: 15px;\n}\n\n/* Empty states */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.empty-state svg {\n  opacity: 0.4;\n  margin-bottom: 12px;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.empty-state span {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n/* ============================================\n   TAB DOCUMENTOS - Layout de 2 paneles\n   ============================================ */\n.documents-tab {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Summary bar */\n.documents-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.summary-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.summary-info svg {\n  color: var(--accent);\n}\n\n.summary-count {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.summary-hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  padding-left: 12px;\n  border-left: 1px solid var(--border-light);\n}\n\n.documents-panels {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 24px;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Panel de documentos */\n.documents-panel {\n  min-height: 400px;\n}\n\n/* Document list header (sorting) */\n.doc-list-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--bg-sunken);\n  border-bottom: 1px solid var(--border-light);\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted);\n}\n\n.header-cell {\n  background: none;\n  border: none;\n  font: inherit;\n  color: inherit;\n  cursor: default;\n  padding: 0;\n}\n\n.header-cell.sortable {\n  cursor: pointer;\n  transition: color 0.15s;\n}\n\n.header-cell.sortable:hover {\n  color: var(--accent);\n}\n\n/* Column widths - shared between header and data rows */\n.header-cell.check-cell,\n.doc-cell.check-cell {\n  width: 36px;\n  flex-shrink: 0;\n}\n\n.header-cell.name-cell,\n.doc-cell.name-cell {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n}\n\n.header-cell.size-cell,\n.doc-cell.size-cell {\n  width: 80px;\n  flex-shrink: 0;\n  text-align: right;\n}\n\n.header-cell.date-cell,\n.doc-cell.date-cell {\n  width: 110px;\n  flex-shrink: 0;\n  text-align: left;\n}\n\n.header-cell.status-cell,\n.doc-cell.status-cell {\n  width: 90px;\n  flex-shrink: 0;\n  text-align: left;\n}\n\n.header-cell.preview-cell,\n.doc-cell.preview-cell {\n  width: 36px;\n  flex-shrink: 0;\n}\n\n.header-cell.actions-cell,\n.doc-cell.actions-cell {\n  width: 36px;\n  flex-shrink: 0;\n}\n\n/* Doc item cell specific styles */\n.doc-cell {\n  display: flex;\n  align-items: center;\n}\n\n.doc-cell.check-cell {\n  justify-content: center;\n}\n\n.doc-cell.name-cell {\n  gap: 10px;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.doc-cell.name-cell:hover .doc-name {\n  color: var(--accent);\n}\n\n.doc-cell.size-cell {\n  justify-content: flex-end;\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n\n.doc-cell.preview-cell,\n.doc-cell.actions-cell {\n  justify-content: center;\n}\n\n/* Folder styles */\n.folder-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  background: var(--bg-sunken);\n  border-bottom: 1px solid var(--border-light);\n  flex-wrap: wrap;\n}\n\n.breadcrumb-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.15s;\n}\n\n.breadcrumb-item:hover {\n  background: var(--bg-surface);\n  color: var(--accent);\n}\n\n.breadcrumb-item.active {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.breadcrumb-item.drag-over {\n  background: var(--accent);\n  color: white;\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.4);\n}\n\n.breadcrumb-separator {\n  color: var(--text-muted);\n}\n\n.doc-item.is-folder {\n  background: var(--bg-sunken);\n}\n\n.doc-item.is-folder:hover {\n  background: var(--bg-surface);\n}\n\n.doc-item.drag-over {\n  background: rgba(99, 102, 241, 0.1);\n  border-color: var(--accent);\n}\n\n.folder-icon {\n  color: #f59e0b;\n}\n\n.status-badge.folder {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.btn-icon.preview,\n.btn-icon.delete {\n  opacity: 1;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  color: var(--text-muted);\n}\n\n.btn-icon.preview:hover {\n  color: var(--accent);\n  background: var(--accent-light);\n}\n\n.doc-date {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n/* File icon emoji */\n.file-icon-emoji {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.file-icon-emoji.large {\n  font-size: 28px;\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.status-badge.ready {\n  background: var(--success-bg);\n  color: var(--success);\n}\n\n.status-badge.processing {\n  background: var(--warning-bg);\n  color: #b06d00;\n}\n\n.status-badge.pending {\n  background: var(--bg-sunken);\n  color: var(--text-muted);\n}\n\n.status-badge.error {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n/* Config panels (template + instructions) */\n.config-panels {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.instructions-panel {\n  min-height: 200px;\n}\n\n.panel-title h4 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.doc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.doc-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--bg-sunken);\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.doc-item:hover {\n  background: var(--bg-surface);\n  border-color: var(--border-medium);\n  box-shadow: var(--shadow-sm);\n}\n\n.doc-item:hover .btn-icon {\n  opacity: 1;\n}\n\n.doc-item.selected {\n  background: var(--accent-light);\n  border-color: var(--accent);\n}\n\n.doc-item.processing {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.doc-item.error {\n  background: var(--error-bg);\n  border-color: #f5c6c6;\n}\n\n.doc-item-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.doc-item-left input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--accent);\n  cursor: pointer;\n}\n\n.status-dot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.status-dot.ready { color: var(--success); }\n.status-dot.processing { color: var(--warning); }\n.status-dot.error { color: var(--error); }\n\n.file-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: var(--border-light);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.file-icon.pdf { background: #fce8e6; color: #c5221f; }\n.file-icon.docx, .file-icon.doc { background: #e8f0fe; color: #1a73e8; }\n.file-icon.xlsx, .file-icon.xls { background: #e6f4ea; color: #1e8e3e; }\n.file-icon.pptx, .file-icon.ppt { background: #fef7e0; color: #f9ab00; }\n.file-icon.txt { background: #f1f3f4; color: #5f6368; }\n.file-icon.jpg, .file-icon.jpeg, .file-icon.png { background: #f3e8fd; color: #8430ce; }\n\n.doc-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.doc-item.selected .doc-name {\n  color: var(--accent-dark);\n}\n\n.doc-item-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-label {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.status-label.processing {\n  background: var(--warning-bg);\n  color: #b06d00;\n}\n\n.status-label.error {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.selection-count {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--accent);\n}\n\n/* Panel de plantilla */\n.template-panel {\n  min-height: 300px;\n}\n\n.drop-zone {\n  min-height: 200px;\n  border: 2px dashed var(--border-medium);\n  border-radius: var(--radius-md);\n  background: var(--bg-sunken);\n  transition: all 0.2s;\n}\n\n.drop-zone.drag-over {\n  border-color: var(--accent);\n  background: var(--accent-light);\n}\n\n.drop-zone.has-template {\n  border-style: solid;\n  border-color: var(--border-light);\n  background: var(--bg-surface);\n}\n\n.template-empty {\n  padding: 48px 20px;\n}\n\n.drop-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 16px;\n  background: var(--border-light);\n  border-radius: 50%;\n  color: var(--text-muted);\n}\n\n.template-doc {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  background: linear-gradient(135deg, #e8f0fe 0%, #f8faff 100%);\n  border: 1px solid #c2d9f7;\n  border-radius: var(--radius-md);\n  margin: 8px;\n}\n\n.template-doc-info {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.template-doc-info .file-icon {\n  width: 44px;\n  height: 44px;\n}\n\n.template-doc-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.template-doc-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.template-doc-hint {\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n/* Action bar */\n.documents-action-bar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 0;\n}\n\n/* ============================================\n   TAB WORKFLOW (TAREAS)\n   ============================================ */\n.workflow-tab,\n.workflow-container,\n.workflow-canvas {\n  width: 100% !important;\n  height: calc(100vh - 180px) !important;\n  display: block !important;\n}\n\n.workflow-canvas {\n  background-color: #f8fafc;\n  background-image: radial-gradient(circle, #cbd5e1 1px, transparent 1px);\n  background-size: 24px 24px;\n  border: 2px dashed #94a3b8;\n  border-radius: 12px;\n  position: relative;\n  overflow: hidden;\n}\n\n.workflow-connections {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.workflow-connections line {\n  pointer-events: stroke;\n}\n\n.workflow-connections g:hover line {\n  stroke: var(--error);\n}\n\n.workflow-node {\n  position: absolute;\n  width: 150px;\n  background: var(--bg-surface);\n  border: 2px solid var(--node-color);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  cursor: move;\n  user-select: none;\n  transition: box-shadow 0.15s, transform 0.1s;\n}\n\n.workflow-node:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.workflow-node.selected {\n  box-shadow: 0 0 0 3px var(--node-color);\n}\n\n.workflow-node.pending .node-header {\n  opacity: 0.7;\n}\n\n.workflow-node.running {\n  animation: pulse 1.5s infinite;\n}\n\n.workflow-node.completed {\n  border-color: var(--success);\n}\n\n.workflow-node.completed .node-header::after {\n  content: '✓';\n  margin-left: auto;\n  color: var(--success);\n  font-weight: bold;\n}\n\n.workflow-node.error {\n  border-color: var(--error);\n}\n\n.workflow-node.error .node-header::after {\n  content: '✗';\n  margin-left: auto;\n  color: var(--error);\n  font-weight: bold;\n}\n\n@keyframes pulse {\n  0%, 100% { box-shadow: var(--shadow-sm); }\n  50% { box-shadow: 0 0 0 4px var(--accent-light); }\n}\n\n.node-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  background: linear-gradient(180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 100%);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.node-icon {\n  font-size: 18px;\n}\n\n.node-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.node-delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.15s;\n}\n\n.workflow-node:hover .node-delete {\n  opacity: 1;\n}\n\n.node-delete:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.node-label {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.node-connectors {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 12px;\n}\n\n.connector {\n  width: 12px;\n  height: 12px;\n  background: var(--bg-surface);\n  border: 2px solid var(--border-medium);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.connector:hover {\n  border-color: var(--accent);\n  background: var(--accent-light);\n}\n\n.connector.output {\n  background: var(--node-color);\n  border-color: var(--node-color);\n}\n\n.workflow-empty {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.workflow-empty h3 {\n  margin: 16px 0 8px;\n  color: var(--text-primary);\n  font-size: 18px;\n}\n\n.workflow-empty p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Panel de configuración del nodo */\n.node-config-panel {\n  width: 300px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.config-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  background: var(--bg-sunken);\n  border-bottom: 1px solid var(--border-light);\n  font-weight: 600;\n  flex-wrap: wrap;\n}\n\n.node-type-badge {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 3px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.node-type-badge.initial {\n  background: var(--accent-light);\n  color: var(--accent);\n}\n\n.node-type-badge.chained {\n  background: #f0fdf4;\n  color: #16a34a;\n}\n\n.input-source {\n  background: linear-gradient(135deg, #f0fdf4, #dcfce7);\n  border: 1px solid #bbf7d0;\n  border-radius: var(--radius-md);\n  padding: 12px;\n  margin-bottom: 4px;\n}\n\n.input-source label {\n  color: #16a34a;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.source-nodes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.source-node-tag {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: white;\n  border: 1px solid #86efac;\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  color: #166534;\n}\n\n.source-node-tag .source-icon {\n  font-size: 14px;\n}\n\n.config-icon {\n  font-size: 20px;\n}\n\n.config-body {\n  padding: 16px;\n}\n\n.config-field {\n  margin-bottom: 16px;\n}\n\n.config-field:last-child {\n  margin-bottom: 0;\n}\n\n.config-field label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.config-field input[type=\"text\"],\n.config-field textarea {\n  width: 100%;\n  padding: 10px 12px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  color: var(--text-primary);\n  resize: vertical;\n}\n\n.config-field input:focus,\n.config-field textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  background: var(--bg-surface);\n}\n\n.config-docs-list {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  background: var(--bg-sunken);\n}\n\n.config-doc-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--border-light);\n  font-size: 13px;\n  color: #1a1d21;\n  transition: background 0.15s;\n}\n\n.config-doc-item:last-child {\n  border-bottom: none;\n}\n\n.config-doc-item:hover {\n  background: var(--bg-surface);\n}\n\n.config-doc-item.selected {\n  background: var(--accent-light);\n}\n\n.config-doc-item input[type=\"checkbox\"] {\n  width: auto;\n  margin: 0;\n}\n\n.config-doc-item span {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #1a1d21;\n}\n\n.config-docs-list .no-docs {\n  padding: 16px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n/* Documentos especiales (modelo e instrucciones) */\n.special-docs-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.special-doc-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.special-doc-option:hover:not(.unavailable) {\n  background: var(--bg-surface);\n  border-color: var(--accent);\n}\n\n.special-doc-option.active {\n  background: var(--accent-light);\n  border-color: var(--accent);\n}\n\n.special-doc-option.unavailable {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.special-doc-option input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.special-doc-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.special-doc-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.special-doc-name {\n  font-size: 11px;\n  color: var(--text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.special-doc-option.active .special-doc-label {\n  color: var(--accent);\n}\n\n.special-doc-option.unavailable .special-doc-label {\n  color: var(--text-muted);\n}\n\n/* Barra de acciones del workflow */\n.workflow-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 0;\n}\n\n.workflow-info {\n  margin-right: auto;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.workflow-warning {\n  color: var(--warning);\n  font-weight: 500;\n}\n\n.draggable-agent {\n  cursor: grab;\n}\n\n.draggable-agent:active {\n  cursor: grabbing;\n}\n\n.form-row {\n  margin-bottom: 24px;\n}\n\n.form-row label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.form-row.inline {\n  display: flex;\n  gap: 16px;\n}\n\n.form-row .field {\n  flex: 1;\n}\n\n.form-row input[type=\"text\"],\n.form-row textarea {\n  width: 100%;\n  padding: 12px 16px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  color: var(--text-primary);\n  transition: all 0.15s;\n  resize: vertical;\n}\n\n.form-row input[type=\"text\"]:focus,\n.form-row textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  background: var(--bg-surface);\n  box-shadow: 0 0 0 3px var(--accent-light);\n}\n\n.agent-selector {\n  display: flex;\n  gap: 12px;\n}\n\n.agent-option {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 20px 16px;\n  background: var(--bg-sunken);\n  border: 2px solid var(--border-light);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.agent-option:hover {\n  border-color: var(--border-medium);\n  background: var(--bg-surface);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n}\n\n.agent-option.selected {\n  border-color: var(--agent-color, var(--accent));\n  background: var(--bg-surface);\n  color: var(--text-primary);\n  box-shadow: var(--shadow-md);\n}\n\n.agent-option .agent-icon {\n  font-size: 28px;\n}\n\n.docs-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 16px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n}\n\n.doc-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  transition: all 0.15s;\n}\n\n.doc-checkbox:hover {\n  border-color: var(--border-medium);\n  box-shadow: var(--shadow-sm);\n}\n\n.doc-checkbox input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--accent);\n}\n\n.doc-checkbox label {\n  flex: 1;\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.template-btn {\n  padding: 6px 12px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.template-btn:hover {\n  background: var(--border-light);\n}\n\n.template-btn.active {\n  background: var(--warning-bg);\n  border-color: var(--warning);\n  color: #7c4d00;\n}\n\n.no-docs {\n  font-size: 13px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 20px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  background: var(--bg-sunken);\n  border-top: 1px solid var(--border-light);\n}\n\n/* Cola de tareas */\n.task-queue {\n  margin-top: 24px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n}\n\n.queue-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.task-queue h4 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.queue-header .btn {\n  padding: 8px 16px;\n  font-size: 13px;\n}\n\n.queue-list {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.queue-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  transition: all 0.15s;\n}\n\n.queue-item:hover {\n  background: var(--bg-surface);\n  box-shadow: var(--shadow-sm);\n}\n\n.queue-number {\n  width: 26px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent-light);\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n}\n\n.queue-icon {\n  font-size: 18px;\n}\n\n.queue-label {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.queue-agent {\n  font-size: 12px;\n  color: var(--text-secondary);\n  padding: 4px 10px;\n  background: var(--border-light);\n  border-radius: var(--radius-sm);\n}\n\n.queue-remove {\n  padding: 6px;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color 0.15s;\n  border-radius: var(--radius-sm);\n}\n\n.queue-remove:hover {\n  color: var(--error);\n  background: var(--error-bg);\n}\n\n/* ============================================\n   TAB EDITOR\n   ============================================ */\n.editor-tab {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 16px;\n}\n\n.execution-status {\n  padding: 16px 20px;\n  background: var(--accent-light);\n  border: 1px solid #c2d9f7;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.status-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n\n.status-text {\n  color: var(--accent-dark);\n  font-weight: 500;\n}\n\n.status-progress {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.progress-bar {\n  height: 6px;\n  background: #c2d9f7;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent) 0%, #4d9fff 100%);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.editor-content {\n  flex: 1;\n  padding: 28px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow-y: auto;\n  min-height: 400px;\n}\n\n.editor-edit-mode {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 16px;\n}\n\n.edit-textarea {\n  flex: 1;\n  width: 100%;\n  min-height: 400px;\n  padding: 20px;\n  border: 1px solid var(--border-medium);\n  border-radius: var(--radius-md);\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.75;\n  color: var(--text-primary);\n  resize: vertical;\n  background: var(--bg-sunken);\n}\n\n.edit-textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-light);\n}\n\n.edit-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-light);\n}\n\n.edit-export-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edit-btn:hover {\n  background: var(--accent-light);\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.output-text {\n  font-size: 14px;\n  line-height: 1.75;\n  color: var(--text-primary);\n}\n\n.output-text h1, .output-text h2, .output-text h3 {\n  margin-top: 1.5em;\n  margin-bottom: 0.5em;\n  color: var(--text-primary);\n}\n\n.output-text p {\n  margin-bottom: 1em;\n}\n\n.output-text p:empty {\n  display: none;\n}\n\n.output-text > *:last-child {\n  margin-bottom: 0;\n}\n\n.output-text ul, .output-text ol {\n  margin-bottom: 1em;\n  padding-left: 1.5em;\n}\n\n.citation {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  margin: 2px 4px 2px 0;\n  background: var(--accent-light);\n  border-radius: var(--radius-sm);\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--accent);\n  vertical-align: middle;\n  cursor: help;\n}\n\n.cursor {\n  display: inline-block;\n  animation: blink 1s infinite;\n  color: var(--accent);\n  font-weight: bold;\n}\n\n@keyframes blink {\n  0%, 50% { opacity: 1; }\n  51%, 100% { opacity: 0; }\n}\n\n.editor-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--text-muted);\n}\n\n.editor-empty svg {\n  margin-bottom: 16px;\n  opacity: 0.4;\n}\n\n.editor-empty p {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.editor-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.refine-actions,\n.export-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.refine-actions span {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-right: 4px;\n}\n\n.editor-actions button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 14px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.editor-actions button:hover {\n  background: var(--bg-surface);\n  border-color: var(--border-medium);\n  box-shadow: var(--shadow-sm);\n}\n\n/* ============================================\n   TAB PREVIEW\n   ============================================ */\n.preview-tab {\n  height: 100%;\n}\n\n.preview-content {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 36px;\n}\n\n.preview-section {\n  margin-bottom: 36px;\n  padding-bottom: 36px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.preview-section:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.preview-section h3 {\n  margin: 0 0 20px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.preview-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  color: var(--text-muted);\n}\n\n.preview-empty svg {\n  margin-bottom: 16px;\n  opacity: 0.4;\n}\n\n/* ============================================\n   SIDEBAR DERECHA\n   ============================================ */\n.sidebar-right {\n  width: 300px;\n  min-width: 300px;\n  height: 100vh;\n  position: sticky;\n  top: 0;\n  background: var(--bg-surface);\n  border-left: 1px solid var(--border-light);\n  box-shadow: -2px 0 8px rgba(0,0,0,0.04);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  transition: width 0.2s, min-width 0.2s;\n}\n\n.sidebar-right.collapsed {\n  width: 20px;\n  min-width: 20px;\n  border: none;\n  padding: 0;\n}\n\n.panel-toggle {\n  position: absolute;\n  top: 20px;\n  left: -14px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 10;\n  transition: all 0.15s;\n  box-shadow: var(--shadow-sm);\n}\n\n.panel-toggle:hover {\n  background: var(--bg-sunken);\n  box-shadow: var(--shadow-md);\n}\n\n.sidebar-right .panel-header {\n  padding: 20px 24px;\n  background: transparent;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.panel-section {\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.panel-section h4 {\n  margin: 0 0 14px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n.agent-card {\n  padding: 14px 16px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  margin-bottom: 10px;\n}\n\n.agent-card.active {\n  background: var(--accent-light);\n  border-color: #c2d9f7;\n}\n\n.agent-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.agent-card-header .agent-icon {\n  font-size: 18px;\n}\n\n.agent-card-header .agent-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.agent-card-task {\n  font-size: 12px;\n  color: var(--text-primary);\n  margin-bottom: 6px;\n}\n\n.agent-card-status {\n  font-size: 11px;\n  color: var(--text-secondary);\n  margin-bottom: 10px;\n}\n\n.agent-progress {\n  height: 4px;\n  background: var(--border-light);\n  border-radius: 2px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.agent-progress-fill {\n  height: 100%;\n  background: var(--accent);\n  border-radius: 2px;\n  transition: width 0.3s;\n}\n\n.agent-card-meta {\n  display: flex;\n  gap: 14px;\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.agent-card-meta span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.queue-mini {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.queue-mini-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--bg-sunken);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  color: var(--text-primary);\n}\n\n.queue-mini-more {\n  font-size: 11px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 6px;\n}\n\n.completed-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.completed-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--success-bg);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  color: var(--success);\n}\n\n.completed-item svg {\n  flex-shrink: 0;\n}\n\n.completed-item span:first-of-type {\n  flex: 1;\n}\n\n.completed-tokens {\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n.panel-section.stats {\n  border-bottom: none;\n}\n\n.stat-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  font-size: 13px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.stat-row:last-child {\n  border-bottom: none;\n}\n\n.stat-row span:first-child {\n  color: var(--text-secondary);\n}\n\n.stat-row span:last-child {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Tiempo de sesión - footer de sidebar */\n.session-time-footer {\n  margin-top: auto;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-sunken);\n}\n\n.session-time-row {\n  display: flex;\n  gap: 16px;\n}\n\n.session-time-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.session-time-label {\n  font-size: 10px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.session-time-value {\n  font-family: 'SF Mono', 'Consolas', monospace;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.session-time-value.current {\n  color: var(--accent);\n}\n\n.session-time-value.total {\n  color: var(--text-primary);\n}\n\n.session-time-history {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-light);\n}\n\n.session-time-history-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  padding: 4px 0;\n  font-size: 11px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  width: 100%;\n}\n\n.session-time-history-toggle:hover {\n  color: var(--text-primary);\n}\n\n.session-time-entries {\n  margin-top: 6px;\n  max-height: 120px;\n  overflow-y: auto;\n}\n\n.session-time-entry {\n  display: flex;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 11px;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.session-time-entry:last-child {\n  border-bottom: none;\n}\n\n.session-time-entry .entry-date {\n  color: var(--text-tertiary);\n  min-width: 40px;\n}\n\n.session-time-entry .entry-time {\n  color: var(--text-secondary);\n  min-width: 45px;\n}\n\n.session-time-entry .entry-duration {\n  margin-left: auto;\n  font-family: 'SF Mono', 'Consolas', monospace;\n  color: var(--text-primary);\n}\n\n/* ============================================\n   ANIMACIONES\n   ============================================ */\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n@media (max-width: 1400px) {\n  .documents-panels {\n    grid-template-columns: 1fr 280px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .sidebar-right {\n    width: 260px;\n    min-width: 260px;\n  }\n\n  .documents-panels {\n    grid-template-columns: 1fr;\n  }\n\n  .template-panel {\n    min-height: 200px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .sidebar-left {\n    width: 220px;\n    min-width: 220px;\n  }\n\n  .sidebar-right.collapsed {\n    width: 0;\n    min-width: 0;\n    border: none;\n  }\n}\n\n/* ============================================\n   TOAST NOTIFICATIONS\n   ============================================ */\n.toast-container {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  font-size: 14px;\n  color: var(--text-primary);\n  animation: slideIn 0.3s ease;\n  min-width: 280px;\n  max-width: 400px;\n}\n\n.toast svg {\n  flex-shrink: 0;\n}\n\n.toast-success {\n  background: var(--success-bg);\n  border-color: #a8dab5;\n  color: var(--success);\n}\n\n.toast-success svg {\n  color: var(--success);\n}\n\n.toast-error {\n  background: var(--error-bg);\n  border-color: #f5c6c6;\n  color: var(--error);\n}\n\n.toast-error svg {\n  color: var(--error);\n}\n\n.toast-info {\n  background: var(--accent-light);\n  border-color: #c2d9f7;\n  color: var(--accent);\n}\n\n.toast-info svg {\n  color: var(--accent);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* ============================================\n   BARRA DE VERSIONES\n   ============================================ */\n.versions-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  margin-bottom: 16px;\n}\n\n.versions-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.version-nav-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.15s;\n  color: var(--text-secondary);\n}\n\n.version-nav-btn:hover:not(:disabled) {\n  background: var(--accent-light);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.version-nav-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.version-indicator {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  min-width: 120px;\n  text-align: center;\n}\n\n.versions-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n}\n\n.version-chip {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 14px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.version-chip:hover:not(:disabled) {\n  background: var(--bg-surface);\n  border-color: var(--border-medium);\n}\n\n.version-chip.active {\n  background: var(--accent-light);\n  border-color: var(--accent);\n}\n\n.version-chip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.version-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.version-chip.active .version-label {\n  color: var(--accent);\n}\n\n.version-time {\n  font-size: 10px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n/* Preview versions */\n.preview-versions-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  margin-bottom: 16px;\n}\n\n.preview-versions-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.preview-versions-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.preview-version-chip {\n  padding: 6px 14px;\n  background: var(--bg-sunken);\n  border: 1px solid var(--border-light);\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.preview-version-chip:hover {\n  background: var(--bg-surface);\n  border-color: var(--border-medium);\n  color: var(--text-primary);\n}\n\n.preview-version-chip.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: white;\n}\n\n.preview-header {\n  padding: 12px 20px;\n  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);\n  border-bottom: 1px solid var(--border-light);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.preview-version-info {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.preview-body {\n  padding: 28px;\n}\n\n/* ============================================\n   PREVIEW MODAL\n   ============================================ */\n.preview-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 40px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.preview-modal {\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  background: var(--bg-surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.preview-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-light);\n  background: linear-gradient(180deg, #fafbfc 0%, #f6f7f9 100%);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.preview-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.preview-modal-title h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.preview-modal-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.preview-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: transparent;\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.preview-modal-close:hover {\n  background: var(--error-bg);\n  border-color: var(--error);\n  color: var(--error);\n}\n\n.preview-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.preview-modal-content {\n  font-size: 14px;\n  line-height: 1.75;\n  color: var(--text-primary);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.preview-modal-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: var(--text-muted);\n}\n\n.preview-modal-empty svg {\n  margin-bottom: 16px;\n  opacity: 0.4;\n}\n\n.preview-modal-empty p {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   AGENTS TAB\n   ============================================ */\n.agents-tab {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.agents-section {\n  background: var(--bg-surface);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-light);\n}\n\n.agents-section .section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: inherit;\n  text-transform: none;\n  letter-spacing: normal;\n  font-size: inherit;\n}\n\n.agents-section .section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 6px 0;\n}\n\n.agents-section .section-description {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Base Agents Grid */\n.base-agents-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 20px;\n}\n\n.base-agent-card {\n  background: var(--bg-surface);\n  border: 2px solid var(--border-light);\n  border-radius: var(--radius-md);\n  padding: 20px;\n  transition: all 0.2s;\n}\n\n.base-agent-card:hover {\n  border-color: inherit;\n  box-shadow: var(--shadow-md);\n}\n\n.base-agent-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.base-agent-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n\n.base-agent-info h4 {\n  margin: 0 0 4px 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.base-agent-type {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.base-agent-description {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n}\n\n.base-agent-card .btn {\n  width: 100%;\n}\n\n/* Custom Agents List */\n.custom-agents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.custom-agent-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  background: var(--bg-sunken);\n  border-radius: var(--radius-md);\n  transition: all 0.15s;\n}\n\n.custom-agent-item:hover {\n  background: var(--accent-light);\n}\n\n.custom-agent-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.custom-agent-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.custom-agent-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--text-primary);\n  margin-bottom: 3px;\n}\n\n.custom-agent-meta {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.custom-agent-item.clickable {\n  cursor: pointer;\n}\n\n.custom-agent-item.clickable:hover {\n  background: var(--accent-light);\n}\n\n.custom-agent-arrow {\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n/* Empty State */\n.agents-section .empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 20px;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.agents-section .empty-state svg {\n  opacity: 0.4;\n  margin-bottom: 16px;\n}\n\n.agents-section .empty-state p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.agents-section .empty-state span {\n  font-size: 13px;\n  margin-top: 6px;\n}\n\n/* ============================================\n   AGENT MODAL\n   ============================================ */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 40px;\n  animation: fadeIn 0.2s ease;\n}\n\n.agent-modal {\n  width: 100%;\n  max-width: 520px;\n  background: var(--bg-surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  animation: slideUp 0.3s ease;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.modal-body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-sunken);\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n.modal-footer-right {\n  display: flex;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.btn.danger {\n  background: transparent;\n  border: 1px solid var(--error);\n  color: var(--error);\n}\n\n.btn.danger:hover {\n  background: var(--error-bg);\n}\n\n/* Form Elements */\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  padding: 10px 12px;\n  border: 1px solid var(--border-medium);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  background: var(--bg-surface);\n  color: var(--text-primary);\n  transition: all 0.15s;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-light);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n  font-family: inherit;\n  line-height: 1.5;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n/* Base Agent Selector */\n.base-agent-selector {\n  display: flex;\n  gap: 12px;\n}\n\n.base-agent-option {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 12px;\n  background: var(--bg-sunken);\n  border: 2px solid transparent;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.base-agent-option:hover {\n  background: var(--accent-light);\n}\n\n.base-agent-option.selected {\n  background: var(--accent-light);\n}\n\n.base-agent-option .option-icon {\n  font-size: 28px;\n}\n\n.base-agent-option .option-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n/* ============================================\n   SIDEBAR AGENTS\n   ============================================ */\n.agent-item {\n  position: relative;\n  border-left: 3px solid var(--agent-color, #6366f1);\n  padding-left: 10px !important;\n}\n\n.agent-item .agent-icon {\n  font-size: 15px;\n}\n\n.agent-item.custom {\n  opacity: 0.9;\n}\n\n.custom-badge {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--agent-color);\n  margin-left: auto;\n}\n\n.custom-agents-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 12px 6px 12px;\n  margin-top: 4px;\n}\n\n.custom-agents-divider span {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #6b7280;\n}\n\n.custom-agents-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.draggable-agent {\n  cursor: grab;\n}\n\n.draggable-agent:active {\n  cursor: grabbing;\n}\n\n/* ============================================\n   OUTPUT TABS (Pestañas por workflow/agente)\n   ============================================ */\n.output-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 12px 20px;\n  background: var(--bg-sunken);\n  border-bottom: 1px solid var(--border-light);\n  overflow-x: auto;\n}\n\n.output-tab {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.output-tab:hover {\n  border-color: var(--border-medium);\n  box-shadow: var(--shadow-sm);\n}\n\n.output-tab.active {\n  background: var(--accent-light);\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px var(--accent-light);\n}\n\n.output-tab-icons {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.output-tab-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n}\n\n.output-tab-arrow {\n  color: var(--text-muted);\n  font-size: 12px;\n  margin: 0 2px;\n}\n\n.output-tab-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.output-tab-versions {\n  font-size: 11px;\n  background: var(--accent);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  margin-left: 6px;\n}\n\n.output-tab.active .output-tab-label {\n  color: var(--accent-dark);\n}\n\n/* ============================================\n   WORKFLOW INFO BAR\n   ============================================ */\n\n.workflow-info-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, var(--bg-elevated) 0%, var(--bg-card) 100%);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n\n.workflow-info-agents,\n.workflow-info-docs {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.workflow-info-label {\n  color: var(--text-muted);\n  font-weight: 500;\n  min-width: 80px;\n}\n\n.workflow-info-agent {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: var(--bg-base);\n  border: 1px solid var(--border-light);\n  border-left-width: 3px;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  color: var(--text-primary);\n}\n\n.workflow-info-agent .agent-icon {\n  font-size: 14px;\n}\n\n.workflow-info-doc {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: var(--accent-bg);\n  border-radius: var(--radius-sm);\n  font-size: 11px;\n  color: var(--accent-dark);\n}\n\n.workflow-info-doc svg {\n  opacity: 0.7;\n}\n\n/* ============================================\n   CHAT TAB - RAG Document Chat\n   ============================================ */\n\n.chat-tab {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-base);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n\n.chat-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  gap: 12px;\n  background: var(--bg-surface);\n}\n\n.chat-layout {\n  display: flex;\n  height: 100%;\n  gap: 0;\n}\n\n/* Panel lateral de documentos */\n.chat-docs-panel {\n  background: var(--bg-surface);\n  border-right: 1px solid var(--border-light);\n  display: flex;\n  flex-direction: column;\n  transition: width 0.2s ease;\n  overflow: hidden;\n}\n\n.chat-docs-panel.expanded {\n  width: 260px;\n  min-width: 260px;\n}\n\n.chat-docs-panel.collapsed {\n  width: 48px;\n  min-width: 48px;\n}\n\n.chat-docs-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-light);\n  transition: background 0.15s ease;\n  width: 100%;\n  text-align: left;\n}\n\n.chat-docs-toggle:hover {\n  background: var(--bg-sunken);\n}\n\n.chat-docs-panel.collapsed .chat-docs-toggle {\n  justify-content: center;\n  padding: 14px 8px;\n}\n\n.chat-docs-panel.collapsed .chat-docs-toggle span:not(.chat-docs-count) {\n  display: none;\n}\n\n.chat-docs-panel.collapsed .chat-docs-count {\n  display: none;\n}\n\n.chat-docs-count {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--accent);\n  background: var(--accent-light);\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.chat-docs-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.chat-docs-empty {\n  padding: 20px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.chat-docs-actions {\n  display: flex;\n  gap: 6px;\n  padding: 4px 4px 8px;\n  border-bottom: 1px solid var(--border-light);\n  margin-bottom: 8px;\n}\n\n.chat-docs-select-all,\n.chat-docs-clear {\n  flex: 1;\n  padding: 6px 8px;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.chat-docs-select-all {\n  background: var(--accent-light);\n  color: var(--accent);\n}\n\n.chat-docs-select-all:hover {\n  background: var(--accent);\n  color: white;\n}\n\n.chat-docs-clear {\n  background: var(--bg-sunken);\n  color: var(--text-secondary);\n}\n\n.chat-docs-clear:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.chat-doc-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  margin-bottom: 2px;\n}\n\n.chat-doc-item:hover {\n  background: var(--bg-sunken);\n}\n\n.chat-doc-item.selected {\n  background: var(--accent-light);\n}\n\n.chat-doc-item input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--accent);\n  cursor: pointer;\n}\n\n.chat-doc-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.chat-doc-name {\n  font-size: 12px;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Area principal del chat */\n.chat-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(180deg, var(--bg-sunken) 0%, var(--bg-surface) 100%);\n  min-width: 0;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.chat-welcome {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 12px;\n}\n\n.chat-welcome-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent-light) 0%, var(--accent) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.chat-welcome h3 {\n  margin: 0;\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.chat-welcome p {\n  margin: 0;\n  max-width: 360px;\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.chat-welcome-hint,\n.chat-welcome-ready {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  margin-top: 8px;\n}\n\n.chat-welcome-hint {\n  background: var(--warning-bg);\n  color: var(--warning);\n}\n\n.chat-welcome-ready {\n  background: var(--success-bg);\n  color: var(--success);\n}\n\n/* Mensajes */\n.chat-message {\n  display: flex;\n  gap: 12px;\n  max-width: 80%;\n  animation: fadeInUp 0.3s ease;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.chat-message.user {\n  align-self: flex-end;\n  flex-direction: row-reverse;\n}\n\n.chat-message-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bg-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n  box-shadow: var(--shadow-sm);\n}\n\n.chat-message.user .chat-message-avatar {\n  background: var(--accent-light);\n}\n\n.chat-message-bubble {\n  background: var(--bg-surface);\n  padding: 14px 18px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.6;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-light);\n}\n\n.chat-message.user .chat-message-bubble {\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);\n  color: white;\n  border: none;\n}\n\n.chat-message.user .chat-message-bubble p {\n  margin: 0;\n}\n\n.chat-message.assistant .chat-message-bubble p:first-child {\n  margin-top: 0;\n}\n\n.chat-message.assistant .chat-message-bubble p:last-child {\n  margin-bottom: 0;\n}\n\n.chat-message.error .chat-message-bubble {\n  background: var(--error-bg);\n  color: var(--error);\n  border-color: var(--error);\n}\n\n.chat-message-bubble.loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--text-secondary);\n}\n\n.chat-typing {\n  display: flex;\n  gap: 4px;\n}\n\n.chat-typing span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--accent);\n  animation: typingBounce 1.4s infinite ease-in-out both;\n}\n\n.chat-typing span:nth-child(1) { animation-delay: -0.32s; }\n.chat-typing span:nth-child(2) { animation-delay: -0.16s; }\n.chat-typing span:nth-child(3) { animation-delay: 0s; }\n\n@keyframes typingBounce {\n  0%, 80%, 100% {\n    transform: scale(0.6);\n    opacity: 0.4;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Fuentes */\n.chat-sources {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-light);\n}\n\n.chat-sources-label {\n  display: block;\n  font-size: 11px;\n  color: var(--text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.chat-sources-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chat-source-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  background: var(--bg-sunken);\n  border-radius: 12px;\n  font-size: 11px;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-light);\n}\n\n/* Input area */\n.chat-input-area {\n  padding: 16px 24px;\n  background: var(--bg-surface);\n  border-top: 1px solid var(--border-light);\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.chat-new-btn {\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--border-light);\n  background: var(--bg-surface);\n  color: var(--text-secondary);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.chat-new-btn:hover {\n  background: var(--bg-sunken);\n  color: var(--text-primary);\n}\n\n.chat-input-wrapper {\n  flex: 1;\n  position: relative;\n}\n\n.chat-input {\n  width: 100%;\n  padding: 12px 18px;\n  border: 2px solid var(--border-light);\n  border-radius: 24px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s ease;\n  background: var(--bg-surface);\n}\n\n.chat-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-light);\n}\n\n.chat-input:disabled {\n  background: var(--bg-sunken);\n  cursor: not-allowed;\n}\n\n.chat-input::placeholder {\n  color: var(--text-muted);\n}\n\n.chat-send-btn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);\n  color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  box-shadow: var(--shadow-md);\n}\n\n.chat-send-btn:hover:not(:disabled) {\n  transform: scale(1.05);\n  box-shadow: var(--shadow-lg);\n}\n\n.chat-send-btn:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* ============================================\n   SELECTION MENU - Menú flotante de selección\n   ============================================ */\n.selection-menu {\n  z-index: 9999;\n  background: var(--bg-elevated);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-xl);\n  border: 1px solid var(--border-light);\n  animation: fadeInScale 0.15s ease-out;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -100%) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -100%) scale(1);\n  }\n}\n\n.selection-menu-buttons {\n  display: flex;\n  gap: 4px;\n  padding: 6px;\n}\n\n.selection-menu-buttons button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.selection-menu-buttons button:hover {\n  background: var(--bg-sunken);\n  color: var(--text-primary);\n}\n\n.selection-menu-buttons button.close-btn {\n  padding: 8px;\n  color: var(--text-muted);\n}\n\n.selection-menu-buttons button.close-btn:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.selection-menu-input {\n  width: 320px;\n  padding: 12px;\n}\n\n.selection-menu-input-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.selection-menu-input-header span {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.selection-menu-input-header button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.selection-menu-input-header button:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.selection-menu-input textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-medium);\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.15s ease;\n}\n\n.selection-menu-input textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-light);\n}\n\n.selection-menu-input textarea::placeholder {\n  color: var(--text-muted);\n}\n\n.selection-menu-input-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.selection-menu-input-actions button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.selection-menu-input-actions button:first-child {\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.selection-menu-input-actions button:first-child:hover {\n  background: var(--bg-sunken);\n  color: var(--text-primary);\n}\n\n.selection-menu-input-actions button.primary {\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);\n  color: white;\n}\n\n.selection-menu-input-actions button.primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.selection-menu-input-actions button.primary:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Selection Menu - Result View */\n.selection-menu-large {\n  width: 480px;\n  max-width: 90vw;\n}\n\n.selection-menu-result {\n  padding: 16px;\n}\n\n.selection-menu-result-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.selection-menu-result-header span {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.selection-menu-result-header button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.selection-menu-result-header button:hover {\n  background: var(--error-bg);\n  color: var(--error);\n}\n\n.selection-menu-result-content {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 12px;\n  background: var(--bg-sunken);\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--text-primary);\n}\n\n.selection-menu-result-content p {\n  margin: 0 0 8px 0;\n}\n\n.selection-menu-result-content p:last-child {\n  margin-bottom: 0;\n}\n\n.selection-menu-result-content code {\n  background: var(--bg-elevated);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.selection-menu-result-content pre {\n  background: var(--bg-elevated);\n  padding: 12px;\n  border-radius: var(--radius-sm);\n  overflow-x: auto;\n}\n\n.selection-menu-result-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-light);\n}\n\n.selection-menu-result-actions button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  background: var(--bg-sunken);\n  color: var(--text-secondary);\n}\n\n.selection-menu-result-actions button:hover {\n  background: var(--border-light);\n  color: var(--text-primary);\n}\n\n.selection-menu-result-actions button.primary {\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);\n  color: white;\n}\n\n.selection-menu-result-actions button.primary:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
